import { render } from "./ModalDiarioGuardado.vue?vue&type=template&id=bea2387e&scoped=true"
import script from "./ModalDiarioGuardado.vue?vue&type=script&lang=js"
export * from "./ModalDiarioGuardado.vue?vue&type=script&lang=js"

import "./ModalDiarioGuardado.vue?vue&type=style&index=0&id=bea2387e&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bea2387e"]])

export default __exports__